import { CompProps } from '@wix/thunderbolt-symbols'
import fastdom from 'fastdom'

const isHorizontalScrollOverflow = (element: Element) => {
	const boundingRect = element.getBoundingClientRect()
	const horizontalOverflow = element.scrollWidth - boundingRect.width
	const verticalOverflow = element.scrollHeight - boundingRect.height

	return horizontalOverflow > verticalOverflow
}

const getScrollPortion = (element: Element, isHorizontalLayout: boolean) => {
	const boundingRect = element.getBoundingClientRect()
	return Math.trunc(isHorizontalLayout ? boundingRect.width : boundingRect.height)
}

const getNewScrollPosition = (element: Element, scrollDirection: string, isHorizontalLayout: boolean) => {
	const currentScrollPosition = Math.trunc(isHorizontalLayout ? element.scrollLeft : element.scrollTop)
	const totalScrollSpace = Math.trunc(isHorizontalLayout ? element.scrollWidth : element.scrollHeight)
	const scrollPortion = getScrollPortion(element, isHorizontalLayout)

	const scrollDirectionFactor = scrollDirection === 'forward' ? 1 : -1
	let newScrollPosition = currentScrollPosition + scrollDirectionFactor * scrollPortion
	if (newScrollPosition + scrollPortion > totalScrollSpace) {
		// return to the begining on forward
		newScrollPosition = 0
	} else if (newScrollPosition < 0) {
		// return to the end on backward scroll
		newScrollPosition = totalScrollSpace
	}

	return newScrollPosition
}

export const scrollInnerContent = (
	containerProps: CompProps,
	containerId: string,
	scrollDirection: 'forward' | 'backward'
) => {
	const overflowWrapperCssClass =
		containerProps.containerProps?.overlowWrapperClassName ||
		containerProps.responsiveContainerProps?.overlowWrapperClassName // yep, very coupled how different containers decided to name this prop
	if (!overflowWrapperCssClass) {
		return
	}
	const containerElement = window!.document.getElementById(containerId)
	const overflowWrapperElement = containerElement!.getElementsByClassName(overflowWrapperCssClass)[0]

	fastdom.measure(() => {
		const isHorizontalLayout = isHorizontalScrollOverflow(overflowWrapperElement)
		const newScrollPosition = getNewScrollPosition(overflowWrapperElement, scrollDirection, isHorizontalLayout)

		fastdom.mutate(() => {
			overflowWrapperElement.scrollTo({
				[isHorizontalLayout ? 'left' : 'top']: newScrollPosition,
				behavior: 'smooth',
			})
		})
	})
}
